/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconDoorOff = createSolidComponent("door-off", "IconDoorOff", [
  ["path", { d: "M3 21h18" }],
  ["path", { d: "M6 21v-15" }],
  [
    "path",
    { d: "M7.18 3.175c.25 -.112 .528 -.175 .82 -.175h8a2 2 0 0 1 2 2v9" }
  ],
  ["path", { d: "M18 18v3" }],
  ["path", { d: "M3 3l18 18" }]
]);

export { IconDoorOff as default };
//# sourceMappingURL=IconDoorOff.js.map
